import { yup } from '@aibees/shared/utils';

export const schema = yup.object().shape({
  name: yup.string().required('List name is required'),
});
